import { Text } from '@mantine/core';
import { ReactNode } from 'react';

type LabeledTextProps = {
    label: string
    children: ReactNode
}

export const LabeledText = ({ label, children }: LabeledTextProps) => {
    return (
        <div className="flex flex-col gap-sm w-full">
            <Text className="text-lg-bold">{label}</Text>
            <Text className="text-lg">
                {children}
            </Text>
        </div>
    );
};
